import { render, staticRenderFns } from "./TopicDetail.vue?vue&type=template&id=1aa78506&"
import script from "./TopicDetail.vue?vue&type=script&lang=js&"
export * from "./TopicDetail.vue?vue&type=script&lang=js&"
import style0 from "./TopicDetail.vue?vue&type=style&index=0&id=1aa78506&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports